<template>
    <div class="filter-block">
        <div @click="open = !open" class="filter-block__header">
            <h6>{{result.NAME}}</h6>
            <div class="def-plus">
                <div></div>
                <div :class="{'def-plus__close': open}"></div>
            </div>
        </div>
        <div class="filter-block__filters">
            <SlideUpDown :modelValue="open">
                <label
                    v-for="item in getItems"
                    :key="item.ID"
                    class="filter-block__checkbox"
                >
                    <input
                        type="checkbox"
                        class="def-checkbox"
                        :id="item.CONTROL_ID"
                        :name="item.CONTROL_NAME"
                        :checked="item.CHECKED"
                        :disabled="item.DISABLED"
                        value="Y"
                    >
                    <span>
                    <span v-html="item.VALUE" />
                    <span class="filter-block__count">{{item.ELEMENT_COUNT}}</span>
                </span>
                </label>
            </SlideUpDown>
            <SlideUpDown
                v-if="getHiddenItems.length"
                :modelValue="secondaryBlock && open"
            >
                <div class="filter-block__more-items">
                    <label
                        v-for="item in getHiddenItems"
                        :key="item.ID"
                        class="filter-block__checkbox"
                    >
                        <input
                            type="checkbox" class="def-checkbox"
                            :id="item.CONTROL_ID"
                            :name="item.CONTROL_NAME"
                            value="Y"
                            :checked="item.CHECKED"
                            :disabled="item.DISABLED"
                        >
                        <span>
                            <span v-html="item.VALUE" />
                            <span v-if="item.ELEMENT_COUNT" class="filter-block__count">
                                {{item.ELEMENT_COUNT}}
                            </span>
                        </span>
                    </label>
                </div>
            </SlideUpDown>
            <span
                v-if="getHiddenItems.length && open"
                @click="secondaryBlock = !secondaryBlock"
                class="filter-block__more"
            >
            <div class="def-plus">
                <div></div>
                <div :class="{'def-plus__close': secondaryBlock}"></div>
                </div>
                {{secondaryBlock ? 'Меньше' : 'Більше'}}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FilterBlock',
        props: ['result'],
        data() {
            return {
                open: true,
                secondaryBlock: false
            }
        },
        computed: {
            getItems() {
                const items = this.result.VALUES;
                if (items) {
                    return Object.values(items).slice(0, 5);
                }

                return [];
            },
            getHiddenItems() {
                const items = this.result.VALUES;
                if (items) {
                    return Object.values(this.result.VALUES).slice(5);
                }

                return [];
            }
        },
    }
</script>

<style lang="scss">
    .filter-block{
        border-bottom: 1px solid #DFDFDF;
        &__header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            //margin-bottom: 21px;
            font-weight: 500;
            font-size: rem(12);
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: #191918;
            margin-top: 21px;
            @include point-md{
                font-size: rem(14);
            }
            svg{
                width: 16px;
                height: 2px;
            }
            .filter-block__plus{
                width: 16px;
                height: 16px;
            }
            &:hover{
                cursor: pointer;
            }
        }
        &__checkbox{
            display: block;
            font-size: rem(14);
            line-height: 110%;
            color: #191918;
            margin-bottom: 17px;
            @include point-md{
                font-size: rem(16);
            }
            &:first-child{
                margin-top: 21px;
            }
            &:last-child{
                margin-bottom: 0;
            }
        }
        &__count{
            color: #757575;
            margin-left: 3px;
        }
        &__filters{
            padding-bottom: 24px;
        }
        &__more-items{
            padding-top: 17px;
            .filter-block__checkbox{
                &:first-child{
                    margin-top: 0;
                }
                &:last-child{
                    margin-bottom: 0px;
                }
            }
        }
        &__more{
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: rem(12);
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #191918;
            margin-top: 16px;
            &:hover{
                cursor: pointer;
            }
            .def-plus{
                margin-right: 10px;
                transform: translateY(-2px);
                div:first-child{
                    width: 9px;
                    height: 1px;
                }
                div:nth-child(2){
                    width: 9px;
                    height: 1px;
                }
            }
        }
        .def-checkbox + * {
            padding-top: 4px;
        }
        .slide-up-down__container{
            position: relative;
        }
    }
    .def-plus{
        position: relative;
        div:first-child{
            width: 16px;
            height: 2px;
            background-color: black;
        }
        div:nth-child(2){
            width: 16px;
            height: 2px;
            position: absolute;
            background-color: black;
            transform: rotate(90deg);
            top: 0;
            transition: .3s linear transform;
            &.def-plus__close{
                transform: rotate(0deg);
            }
        }
    }
</style>